import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export function Img({ src, alt, caption }) {
  return (
    <figure className="my-4 border rounded-lg overflow-hidden shadow-sm">
      <img src={src} alt={alt} className="w-full" loading="lazy" />
      {caption && <figcaption className="text-xs text-slate-500 px-3 py-2 bg-slate-50 border-t">{caption}</figcaption>}
    </figure>
  );
}

export function Section({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border rounded-lg mb-3 overflow-hidden">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-4 text-left hover:bg-slate-50 transition-colors">
        <span className="font-semibold text-slate-800">{title}</span>
        {open ? <ChevronDown size={18} className="text-slate-400" /> : <ChevronRight size={18} className="text-slate-400" />}
      </button>
      {open && <div className="px-4 pb-4 border-t">{children}</div>}
    </div>
  );
}

export function Step({ num, title, children }) {
  return (
    <div className="flex gap-3 mb-4">
      <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">{num}</div>
      <div className="flex-1">
        <p className="font-medium text-slate-800 mb-1">{title}</p>
        <div className="text-sm text-slate-600">{children}</div>
      </div>
    </div>
  );
}

export const SCREENSHOTS = {
  dashboard: "/screenshots/dashboard.png",
  newContract: "/screenshots/new-contract.png",
  templates: "/screenshots/templates.png",
  clauses: "/screenshots/clauses.png",
  compliance: "/screenshots/compliance.png",
  reports: "/screenshots/reports.png",
  userManagement: "/screenshots/user-management.png",
  approvalPolicies: "/screenshots/approval-policies.png",
  settings: "/screenshots/settings.png",
  management: "/screenshots/management.png",
  auditLog: "/screenshots/audit-log.png",
  submitReview: "/screenshots/submit-review.png",
  workflowExternal: "/screenshots/workflow-external.png",
  supplierReview: "/screenshots/supplier-review.png",
};
